// Редирект незалогиненного на signin с возвратом на исходный маршрут.
//
// Вынесено из beforeEach в router/index.js отдельным модулем ради проверяемости
// (импорт "@/router" в тест-бандл ломает моки $route у чужих спеков — см.
// staffGate.js). Signin после входа делает push({ path: query.from }).
//
// Именно объект location, а не строка "/signin?from=" + fullPath: строку
// vue-router разбирает как URL, и всё после первого `&` в fullPath становилось
// query самого signin, а `#hash` — его hash. Deep link /bookings/123?tab=x&panel=y#top
// после входа открывался как /bookings/123?tab=x. В объекте query роутер
// кодирует значение сам, а push({ path }) на обратном пути его раскодирует.
export function signinRedirectFor(fullPath) {
  return { path: "/signin", query: { from: fullPath } };
}

export function postSigninPath({ from, isAgent }) {
  if (typeof from === "string" && from.startsWith("/")) return from;
  return isAgent ? "/search_free" : "/dashboard";
}

export function sessionEndSigninRedirect(route, returnTo = null) {
  const fullPath = returnTo || (route && route.path === "/oauth/consent" && route.fullPath);
  return fullPath ? signinRedirectFor(fullPath) : { name: "Signin" };
}
